const permissions = {
  'permissions-breadcrumbs': 'Права доступа',
  'permissions-search-by': 'Поиск по имени либо отображаемому имени...',
};

export default permissions;
